import React from 'react';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import {
	PACKAGE_NAME,
	TEAM_NAME,
} from '@atlassian/jira-atlassian-navigation-nav4-common/src/common/constants.tsx';
import getMeta from '@atlassian/jira-get-meta';
import type { AtlaskitAtlassianNavigationNav4Props } from './types.tsx';
import { AtlassianNavigationNav4 } from './AtlassianNavigationNav4.tsx';

export function TopNav4(props: AtlaskitAtlassianNavigationNav4Props): React.JSX.Element | null {
	// This is defensive code to prevent making a request for data that will never be returned.
	// Only Customer Accounts have customer service access. These are non-Atlassian accounts considered
	// second-party party customers and should only have access to the JSM Help Center. They should
	// never have access to the regular Jira UI so should never see this top navigation. If we detect
	// that this is a customer account request we will not render the top navigation at all.
	// See https://jplat.atlassian.net/browse/BLU-7341 for context.
	if (getMeta('ajs-account-type') === 'customer') {
		return null;
	}

	return (
		<UFOSegment name="atlaskit-atlassian-navigation-nav4">
			<JSErrorBoundary
				id="AtlaskitAtlassianNavigationNav4"
				packageName={PACKAGE_NAME}
				teamName={TEAM_NAME}
				fallback="flag"
			>
				<AtlassianNavigationNav4 {...props} />
			</JSErrorBoundary>
		</UFOSegment>
	);
}
